import { render, staticRenderFns } from "./PersonAndPay.vue?vue&type=template&id=148e916e&scoped=true&"
import script from "./PersonAndPay.vue?vue&type=script&lang=js&"
export * from "./PersonAndPay.vue?vue&type=script&lang=js&"
import style0 from "./PersonAndPay.vue?vue&type=style&index=0&id=148e916e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e916e",
  null
  
)

export default component.exports